import utils from "../common/util";
import cmpLogResultsBtn from "./cmp-log-results-btn";

/**
 * Initialise the countdown timer
 * @param element
 */
const cmpCountdownTimer = {
    component: null,

    init: function (element)
    {

        utils.log('cmpCountdownTimer initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);
        _.timeInSecs = null;
        _.ticker = null;
        _.animating = false;

        _.component = element;
        _.countdown = 0;
        _.countdownNumber = document.getElementById('countdown-number');
        _.startTimerButton = document.getElementById('cmp-game-play__start-timer-button-container');
        _.ding = new Audio();
        _.ding.src = '/assets/audio/bell-ding.mp3';

        _.countdownNumber.textContent = _.formatCountdown(_.countdown);

        _.onClickEvent(_.startTimerButton);
    },

    /**
     * Set on click events for the timer
     */
    onClickEvent: function (element)
    {
        const _ = this;

        element.addEventListener('click', () =>
            {
                if (!_.animating) {
                    utils.log('cmpCountdownTimer clicked. Counting down. ', 'info');

                    _.animating = true;

                    _.countdown = _.dataContainer.getAttribute('data-countdown-from');

					// setTimeout(() => {_.ding.play();}, 2000)
					utils.sleep(_.countdown * 1000).then(() => {
						// if (playSound) {
						console.log(_.countdown -1);
							void _.ding.play();
						// }
					})

                    _.hideTimerStartButton();
                    _.startTimer(_.countdown - 1);
                } else {
                    utils.log('cmpCountdownTimer clicked but countdown is already in progress. Click is ignored', 'info');
                }
            }
        );
    },

    /**
     * Start the timer countdown
     *
     * @param seconds
     */
    startTimer: function (seconds)
    {
        const _ = this;

        _.hideTimerStartButton();
        cmpLogResultsBtn.showLogResultsButtons();


        _.timeInSecs = parseInt(seconds);
        _.ticker = setInterval(() =>
        {
            _.tick()
        }, 1000);
    },

    /**
     * Stop the countdown timer
     */
    stopTimer(playSound = false)
    {
        const _ = this;
	    console.log(_.ticker);

        // if (playSound) {
        //     void _.ding.play() ;
        // }

        _.animating = false;

        clearInterval(_.ticker);
    },

    /**
     * Action for every second of the countdown
     */
    tick: function ()
    {
        const _ = this;
        let seconds = _.timeInSecs;
        if (seconds > 0) {
            _.timeInSecs--;
        } else {
            _.stopTimer(true);
        }

        _.setCountdownClock(seconds);

    },

    /**
     * Format the countdown into minutes : seconds
     * @param seconds
     * @returns {{minutes: number, seconds}}
     */
    formatCountdown: function (seconds)
    {
        let minutes = Math.floor(seconds / 60);
        seconds %= 60;

        return {
            'minutes': minutes,
            'seconds': seconds
        };
    },

    /**
     * Update the UI with the appropriate time
     * @param seconds
     */
    setCountdownClock: function (seconds)
    {
        const _ = this;

        let time = _.formatCountdown(seconds);
        _.countdownNumber.innerHTML = ((time.minutes < 10) ? "0" : "") + time.minutes + ":" + ((time.seconds < 10) ? "0" : "") + time.seconds;
    },

    /**
     * Brings the timer into view
     */
    showCountdownTimer: function ()
    {
        const _ = this;

	    utils.animateAndShow(_.timerContainer, 'opacity-0');
	    utils.animateAndShow(_.startTimerButton, 'opacity-0');
    },

    /**
     * Hides the timer from the view
     */
    hideCountdownTimer: function ()
    {
        const _ = this;

        utils.showHideElement(_.timerContainer, 'hide');
        _.hideTimerStartButton();
    },

    /**
     * Hides the timer start button from the view
     */
    hideTimerStartButton: function ()
    {
        const _ = this;
        utils.showHideElement(_.startTimerButton, 'hide');
        _.startTimerButton.classList.add('opacity-0');
    }
}

export default cmpCountdownTimer;
